module.exports = __webpack_public_path__ + "static/media/editor-modal-close.da7a8489.svg";